'use client'

import { useQuery } from '@tanstack/react-query'
import { USER_QUERY_KEY, fetchUser } from '@/shared/lib/queryClient'
import type { User } from '@supabase/supabase-js'

// Shared identity for the whole client tree. Every component that needs the
// signed-in user reads from this one query, so a screen fires a single
// validated getUser() instead of one per consumer. The auth listener in
// QueryProvider keeps this cache in sync on sign-in / sign-out / token refresh,
// so we never need to refetch on our own — hence the long staleTime. Store
// actions read the same cache via getCurrentUser() (see lib/queryClient).
export function useUser() {
  return useQuery<User | null>({
    queryKey: USER_QUERY_KEY,
    queryFn: fetchUser,
    staleTime: Infinity,
  })
}
